module.exports = __webpack_public_path__ + "2550d62f84aa1b8263efdad11e3d9afa.svg";